import { z } from 'zod';

export default function passwordValidation(translator: (key: string) => string) {
    return z
        .string({ message: translator('error.requiredField') })
        .min(8, translator('error.passwordLength'))
        .max(15, translator('error.passwordLength'))
        .regex(/[a-z]/, translator('error.passwordLowerCaseRequired'))
        .regex(/[A-Z]/, translator('error.passwordUpperCaseRequired'))
        .regex(/[0-9]/, translator('error.passwordNumberRequired'))
        .regex(/[!@#$%^&*(),.?":{}|<>]/, translator('error.passwordSpecialCharacterRequired'));
}
